{
  "header": {
    "title": "Enkätöversikt",
    "description": "Skapa, hantera och analysera medarbetarundersökningar för att få djupare insikter",
    "createButton": "Skapa en enkät",
    "createModal": {
      "title": "Skapa en enkät",
      "useTemplate": {
        "title": "Använd mallar",
        "description": "Utforska förbyggda mallar och anpassa dem efter dina mål",
        "buttonLabel": "Se mallar"
      },
      "createTemplate": {
        "title": "Skapa från början",
        "description": "Skapa din unika enkät med det format du föredrar",
        "buttonLabel": "Skapa enkät"
      }
    },
    "unsavedChangesDialog": {
      "title": "Osparade ändringar i enkäten",
      "description": "Du har osparade ändringar som kommer att gå förlorade om du lämnar sidan. Vill du fortsätta utan att spara?",
      "exitButton": "Avsluta utan att spara",
      "keepEditingButton": "Fortsätt redigera"
    }
  },
  "tabs": {
    "active": "Aktiva",
    "finished": "Avslutade",
    "scheduled": "Planerade",
    "drafts": "Utkast"
  },
  "searchInput": {
    "placeholder": "Sök undersökningar"
  },
  "tagsDropdown": {
    "triggerLabel": "Taggar",
    "placeholder": "Hitta en tagg",
    "options": {
      "employeeEngagement": "Medarbetarengagemang",
      "workplaceCulture": "Arbetsplatskultur",
      "teamSatisfaction": "Teamsatisfaction",
      "performanceFeedback": "Prestationsfeedback",
      "organizationalImprovement": "Organisatorisk förbättring",
      "usa": "USA",
      "europe": "Europa",
      "asia": "Asien",
      "ukraine": "Ukraina"
    }
  },
  "builderPage": {
    "header": {
      "title": "Enkätbyggare",
      "backButton": "Gå tillbaka",
      "seePreviewButton": "Se förhandsvisning",
      "shareButton": "Dela",
      "saveButton": {
        "label": "Spara",
        "options": {
          "draft": "Spara som utkast",
          "template": "Spara som mall",
          "companyTemplate": "Spara som företagsmall"
        }
      },
      "publishButton": "Publicera"
    },
    "tabs": {
      "surveySetup": {
        "title": "Enkätinställningar",
        "coverImageSection": {
          "title": "Omslagsbild",
          "imageUpload": "Ladda upp en bild eller släpp den här",
          "imageSize": "Max. 800x400 px",
          "formatImage": "PNG, JPG format",
          "titleInput": {
            "label": "Enkätens titel",
            "placeholder": "Ange en titel"
          },
          "descriptionInput": {
            "label": "Enkätbeskrivning",
            "placeholder": "Ange en beskrivning"
          },
          "tagsInput": {
            "label": "Enkättaggar",
            "placeholder": "Ange tagg och tryck enter"
          }
        },
        "question": {
          "title": "Fråga #{{questionCount}}",
          "required": "Obligatorisk",
          "type": {
            "title": "Frågetyp",
            "textType": "Text",
            "scaleType": "Skala",
            "choiceType": "Val"
          },
          "questionInput": {
            "label": "Fråga",
            "placeholder": "Ange fråga här"
          },
          "descriptionInput": {
            "label": "Frågebeskrivning",
            "placeholder": "Ange beskrivning här"
          },
          "span": {
            "title": "Intervall",
            "to": "till"
          },
          "spanLabels": {
            "title": "Intervalletiketter",
            "placeholder": "Etikett (valfritt)"
          },
          "options": {
            "title": "Valmöjligheter",
            "placeholder": "Ange ett val",
            "addChoiceButton": "Lägg till ett val",
            "multipleAnswers": "Flera svar"
          },
          "addNewQuestionBUtton": "Lägg till ny fråga"
        },
        "cardPreview": {
          "title": "Förhandsvisning av enkätkort",
          "tabs": {
            "cover": {
              "label": "Omslag",
              "time": "1-2 minuter"
            },
            "template": {
              "label": "Mall",
              "time": "1-2 minuter"
            }
          }
        }
      },
      "audience": {
        "title": "Publik",
        "audienceSection": {
          "title": "Publikstorlek"
        },
        "surveyAudienceSection": {
          "title": "Enkätpublik",
          "options": {
            "entireCompany": "Hela företaget"
          }
        },
        "segmentationSection": {
          "title": "Segmenteringsalternativ",
          "selectAll": "Välj alla",
          "options": {
            "location": {
              "label": "Plats",
              "options": {
                "us": "USA",
                "europe": "Europa",
                "asia": "Asien"
              }
            },
            "department": {
              "label": "Avdelning",
              "options": {
                "executiveTeam": "Ledningsteam",
                "technicalTeam": "Tekniskt team",
                "designTeam": "Designteam",
                "productTeam": "Produktteam",
                "salesTeam": "Säljteam",
                "marketingTeam": "Marknadsföringsteam",
                "financeTeam": "Ekonomiteam"
              }
            },
            "gender": {
              "label": "Kön",
              "options": {
                "male": "Man",
                "female": "Kvinna"
              }
            },
            "tenure": {
              "label": "Anställningstid",
              "options": {
                "lessThanHalf": "<0,5 år",
                "halfToOne": "0,5–1 år",
                "oneToTwo": "1–2 år",
                "twoToFive": "2–5 år",
                "moreThanFive": "5+ år"
              }
            }
          }
        },
        "distributionSection": {
          "title": "Distributionsmetoder",
          "options": {
            "mail": "Automatiserad e-post",
            "link": "Manuell länkdelning"
          }
        }
      },
      "delivery": {
        "title": "Leverans",
        "startDate": {
          "label": "Startdatum",
          "placeholder": "Välj datum"
        },
        "endDate": {
          "label": "Slutdatum",
          "closeAfter": "Stäng efter",
          "days": "dagar",
          "closeButton": "Stäng inte automatiskt"
        }
      },
      "translation": {
        "title": "Översättning",
        "tabs": {
          "info": {
            "label": "Info"
          },
          "question": {
            "label": "Fråga {{questionCount}}"
          }
        }
      }
    }
  },
  "preview": {
    "header": {
      "backButton": "Förhandsvisning av enkät",
      "publishButton": "Publicera"
    },
    "question": {
      "finishSurvey": "Avsluta undersökning",
      "nextQuestion": "Nästa fråga",
      "previousQuestion": "Föregående fråga"
    }
  },
  "detailsPage": {
    "header": {
      "backButton": "Tillbaka till enkätöversikten",
      "exportButton": "Exportera"
    },
    "surveyOverviewSection": {
      "title": "Enkätöversikt",
      "invitedBlock": {
        "title": "Inbjudna",
        "usersCount": "{{usersCount}} användare"
      },
      "responsesBlock": {
        "title": "Svar"
      },
      "info": {
        "creator": "Skapare",
        "startDate": "Startdatum",
        "endDate": "Slutdatum",
        "segmentation": "Segmentering",
        "distributionMethod": "Distributionsmetod"
      }
    },
    "question": {
      "questionCount": "Fråga #{{questionCount}}",
      "responseCount": "{{responseCount}} svar"
    },
    "asnwersSection": {
      "title": "Svar"
    }
  }
}
